import { recipesCopy } from '@/copy'
import { Button } from '@/ui/Button/Button'
import { Chip } from '@/ui/Chip/Chip'
import { EmptyState } from '@/ui/EmptyState/EmptyState'
import { Inline } from '@/ui/layout/Inline'
import { Stack } from '@/ui/layout/Stack'
import { Text } from '@/ui/layout/Text'
import { RowList, RowListItem } from '@/ui/RowList/RowList'
import type { RecipeView } from '../../api/recipes'
import styles from './RecipeCatalog.module.css'

interface Props {
  recipes: RecipeView[]
  onSetUp: (recipeId: string) => void
}

/** Recipes the workspace can set up, each with what it takes events from. */
export function RecipeCatalog({ recipes, onSetUp }: Props) {
  if (recipes.length === 0) {
    return (
      <EmptyState variant="inline" description={recipesCopy.catalog.empty} />
    )
  }
  return (
    <RowList hover={false}>
      {recipes.map((r) => (
        <RowListItem key={r.id}>
          <Stack gap="space-4" className={styles.main}>
            <Inline gap="space-8">
              <Text>{r.title}</Text>
              {r.origin === 'workspace' && (
                <Chip
                  variant="kind"
                  label={recipesCopy.catalog.workspaceOrigin}
                />
              )}
            </Inline>
            <Text variant="caption" tone="text-mute">
              {r.description} {recipesCopy.catalog.source(r.source.label)}
            </Text>
          </Stack>
          <Button
            variant="outline"
            className={styles.action}
            aria-label={recipesCopy.catalog.setUpName(r.title)}
            onClick={() => onSetUp(r.id)}
          >
            {recipesCopy.catalog.setUp}
          </Button>
        </RowListItem>
      ))}
    </RowList>
  )
}
